import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import styles from './styles'

const LANGUAGES = [
  { name: 'Afrikaans', value: 'af' },
  { name: 'Arabic', value: 'ar' },
  { name: 'Bengali', value: 'bn' },
  { name: 'Bulgarian', value: 'bg' },
  { name: 'Chinese (Simplified)', value: 'zh-Hans' },
  { name: 'Chinese (Traditional)', value: 'zh-Hant' },
  { name: 'Croatian', value: 'hr' },
  { name: 'Czech', value: 'cs' },
  { name: 'Danish', value: 'dk' },
  { name: 'Dutch', value: 'nl' },
  { name: 'English (US)', value: 'en' },
  { name: 'English (UK)', value: 'en-GB' },
  { name: 'Filipino', value: 'fil' },
  { name: 'Finnish', value: 'fi' },
  { name: 'French', value: 'fr' },
  { name: 'German', value: 'de' },
  { name: 'Greek', value: 'el' },
  { name: 'Hungarian', value: 'hu' },
  { name: 'Indonesian', value: 'id' },
  { name: 'Italian', value: 'it' },
  { name: 'Japanese', value: 'ja' },
  { name: 'Korean', value: 'ko' },
  { name: 'Lithuanian', value: 'lt' },
  { name: 'Malay', value: 'ms' },
  { name: 'Marathi', value: 'mr' },
  { name: 'Norwegian', value: 'no' },
  { name: 'Persian', value: 'fa' },
  { name: 'Polish', value: 'pl' },
  { name: 'Portuguese', value: 'pt' },
  { name: 'Romanian', value: 'ro' },
  { name: 'Russian', value: 'ru' },
  { name: 'Slovak', value: 'sk' },
  { name: 'Spanish', value: 'es' },
  { name: 'Swahili', value: 'sw' },
  { name: 'Swedish', value: 'sv' },
  { name: 'Tamil', value: 'ta' },
  { name: 'Telugu', value: 'te' },
  { name: 'Thai', value: 'th' },
  { name: 'Turkish', value: 'tr' },
  { name: 'Ukrainian', value: 'uk' },
  { name: 'Urdu', value: 'ur' },
  { name: 'Vietnamese', value: 'vi' },
]

/** Course language (the language the AI writes the course in). */
const CourseLanguageCode = ({ classes, onCourseLanguageCodeChange }) => {
  const [value, setValue] = React.useState('en')

  return (
    <div className={classes.courseInfo}>
      <span className={classes.sectionLabel}>Course language</span>
      <div className={classes.selectWrap}>
        <select
          className={classes.select}
          value={value}
          onChange={event => {
            setValue(event.target.value)
            onCourseLanguageCodeChange(event.target.value)
          }}
        >
          {LANGUAGES.map(language => (
            <option key={language.value} value={language.value}>
              {language.name}
            </option>
          ))}
        </select>
        <span className={classes.selectChevron}>
          <Icon icon="tabler:chevron-down" width={16} height={16} />
        </span>
      </div>
    </div>
  )
}

export default withStyles(styles)(CourseLanguageCode)
